function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import ServiceFactory from "../../service";
import ClipPlayer from "./clip-player";
import { runAgent, waitAgent, runIdOf } from "./agent-run";
import { loadBrandKit } from "../../functions/brand-kit";

// Content Hub Tier 3 (2026-10-01): video trim and clip proposals. Both free (ffmpeg on the agent worker).
// Every cut is saved as a new video version under the original, like image edits.

function svc(api) {
  const S = ServiceFactory.getType(api, "product");
  return new S();
}
async function safe(promise, fallback) {
  try {
    return (await promise) || fallback;
  } catch (e) {
    return fallback;
  }
}
function toast(msg) {
  const t = document.querySelector("paper-toast");
  if (t) t.show(msg);
}
const fmt = s => {
  const n = Math.max(0, Math.round(Number(s) || 0));
  return `${Math.floor(n / 60)}:${String(n % 60).padStart(2, "0")}`;
};
const num = (v, d) => {
  const n = parseFloat(v);
  return isNaN(n) ? d : n;
};
const VIDEO_TARGETS = [["story", "Reels / Stories 9:16", 1080, 1920], ["square", "Instagram 1:1", 1080, 1080], ["portrait", "Feed 4:5", 1080, 1350], ["wide", "YouTube 16:9", 1920, 1080]];
const uuid = () => window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : String(Date.now());

/** The edit tools render as a popup (Content Hub, builders) or inline on the clip workspace page (inline prop). */
export function EditFrame({
  inline,
  busy,
  onClose,
  style,
  innerRef,
  children
}) {
  if (inline) return /*#__PURE__*/React.createElement("div", {
    className: "vw-tool",
    ref: innerRef
  }, children);
  return /*#__PURE__*/React.createElement("div", {
    className: "wa-modal-backdrop hub-edit-backdrop",
    onClick: () => {
      if (!busy) onClose();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "wa-modal hub-edit-modal",
    style: style,
    onClick: e => e.stopPropagation(),
    ref: innerRef
  }, children));
}

/** Drag a box over a video frame (uses the poster or the current frame). Fractions of the frame. */
class FrameRect extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      drag: null
    });
    _defineProperty(this, "frac", e => {
      const box = this.el.getBoundingClientRect();
      return {
        x: Math.max(0, Math.min(1, (e.clientX - box.left) / box.width)),
        y: Math.max(0, Math.min(1, (e.clientY - box.top) / box.height))
      };
    });
    _defineProperty(this, "down", e => {
      e.preventDefault();
      this.setState({
        drag: {
          a: this.frac(e),
          b: this.frac(e)
        }
      });
    });
    _defineProperty(this, "move", e => {
      if (!this.state.drag) return;
      this.setState({
        drag: {
          ...this.state.drag,
          b: this.frac(e)
        }
      });
    });
    _defineProperty(this, "up", () => {
      const d = this.state.drag;
      if (!d) return;
      this.setState({
        drag: null
      });
      const x = Math.min(d.a.x, d.b.x),
        y = Math.min(d.a.y, d.b.y),
        w = Math.abs(d.a.x - d.b.x),
        h = Math.abs(d.a.y - d.b.y);
      if (w < 0.02 || h < 0.02) {
        this.props.onRect(null);
        return;
      }
      this.props.onRect({
        x: +x.toFixed(4),
        y: +y.toFixed(4),
        w: +w.toFixed(4),
        h: +h.toFixed(4)
      });
    });
  }
  render() {
    const {
      src,
      rect
    } = this.props;
    const d = this.state.drag;
    const live = d ? {
      x: Math.min(d.a.x, d.b.x),
      y: Math.min(d.a.y, d.b.y),
      w: Math.abs(d.a.x - d.b.x),
      h: Math.abs(d.a.y - d.b.y)
    } : rect;
    return /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-stage-wrap"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-canvas draw",
      ref: r => {
        this.el = r;
      },
      onMouseDown: this.down,
      onMouseMove: this.move,
      onMouseUp: this.up,
      onMouseLeave: this.up
    }, /*#__PURE__*/React.createElement("video", {
      src: src,
      muted: true,
      playsInline: true,
      preload: "metadata",
      style: {
        display: "block",
        maxWidth: "100%",
        maxHeight: "48vh",
        pointerEvents: "none"
      }
    }), live && live.w > 0 && /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-rect",
      style: {
        left: `${live.x * 100}%`,
        top: `${live.y * 100}%`,
        width: `${live.w * 100}%`,
        height: `${live.h * 100}%`
      }
    })));
  }
}
async function trimToVersion(asset, start, end, label, batchId) {
  const r = await runAgent("content_video_trim_agent", `trim ${fmt(start)} to ${fmt(end)}`, {
    videoUrl: asset.url,
    start: String(start),
    end: String(end),
    label: label || ""
  });
  const done = await waitAgent(runIdOf(r), 4000, 90);
  const ctx = done && done.ctx || {};
  const res = done && done.res || {};
  const url = ctx.outputUrl || res.outputUrl || ctx.urls && ctx.urls[0];
  if (!done.ok || !url) {
    await safe(svc(`/content/assets/${String(asset.id)}/edits`).postAsync({
      action: "trim",
      params: JSON.stringify({
        start,
        end
      }),
      status: "failed",
      error: done && done.timeout ? "timed out" : "no output",
      credits: 0,
      batchId
    }), null);
    return null;
  }
  const saved = await safe(svc(`/content/assets/${String(asset.id)}/edits`).postAsync({
    action: "trim",
    params: JSON.stringify({
      start,
      end
    }),
    status: "done",
    url,
    width: ctx.width || res.width || null,
    height: ctx.height || res.height || null,
    durationSeconds: Math.round(Number(ctx.seconds || res.seconds || end - start)),
    posterUrl: ctx.posterUrl || res.posterUrl || null,
    label: label || `Trim ${fmt(start)}-${fmt(end)}`,
    credits: 0,
    batchId
  }), null);
  return saved && saved.version;
}

/** Trim: player + start/end, both settable from the playhead. */
export class TrimModal extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      start: 0,
      end: 0,
      busy: false,
      step: "",
      versions: []
    });
    _defineProperty(this, "_alive", true);
    _defineProperty(this, "onKey", e => {
      if (e.key === "Escape" && !this.state.busy) this.props.onClose();
    });
    _defineProperty(this, "load", async () => {
      const a = this.props.asset;
      const d = await safe(svc(`/content/assets/${String(a.id)}/versions`).getAsync(), {
        items: []
      });
      if (this._alive) this.setState({
        versions: d && d.items || [],
        end: Number(a.durationSeconds) || 0
      });
    });
    _defineProperty(this, "setFromPlayer", which => {
      const v = this.video();
      if (!v) return;
      const t = Math.round(v.currentTime * 10) / 10;
      this.setState(which === "start" ? {
        start: t
      } : {
        end: t
      });
    });
    _defineProperty(this, "seek", t => {
      const v = this.video();
      if (v) {
        v.currentTime = Number(t) || 0;
      }
    });
    _defineProperty(this, "extend", async () => {
      const a = this.props.asset;
      const prompt = (this.state.extendPrompt || "").trim();
      if (!prompt) return;
      this.setState({
        busy: true,
        step: "Extending…"
      });
      try {
        const aspect = a.width && a.height && a.height > a.width ? "9:16" : "16:9";
        const r = await runAgent("content_video_extend_agent", prompt, {
          videoUrl: a.url,
          prompt,
          aspectRatio: aspect
        });
        const done = await waitAgent(runIdOf(r), 5000, 90);
        const ctx = done && done.ctx || {};
        const res = done && done.res || {};
        const url = ctx.outputUrl || res.outputUrl;
        if (!done.ok || !url) {
          toast(done && done.timeout ? "Still working: the extended version will appear in Assets." : "The extension did not finish.");
          return;
        }
        const saved = await safe(svc(`/content/assets/${String(a.id)}/edits`).postAsync({
          action: "extend_video",
          prompt,
          status: "done",
          url,
          width: ctx.width || null,
          height: ctx.height || null,
          durationSeconds: Math.round(Number(ctx.seconds || 0)) || null,
          posterUrl: ctx.posterUrl || null,
          label: "Extended",
          credits: 40
        }), null);
        toast(saved && saved.version ? `Saved as v${saved.version.version}.` : "Extended.");
        if (this.props.onSaved) this.props.onSaved(saved && saved.version);
        await this.load();
      } catch (e) {
        toast(e && e.outOfCredits ? "Out of generation credits: add a credit pack under Billing & Usage (account.plunk.io)." : e && e.message || "Could not start the extension.");
      } finally {
        if (this._alive) this.setState({
          busy: false,
          step: ""
        });
      }
    });
    _defineProperty(this, "apply", async () => {
      const {
        start,
        end
      } = this.state;
      const a = this.props.asset;
      if (!(end > start)) {
        toast("End must be after start.");
        return;
      }
      this.setState({
        busy: true,
        step: "Cutting…"
      });
      try {
        const v = await trimToVersion(a, start, end, null, null);
        if (!v) {
          toast("The cut did not finish.");
          return;
        }
        toast(`Saved as v${v.version}.`);
        if (this.props.onSaved) this.props.onSaved(v);
        await this.load();
      } catch (e) {
        toast(e && e.message || "Could not start the cut.");
      } finally {
        if (this._alive) this.setState({
          busy: false,
          step: ""
        });
      }
    });
  }
  componentDidMount() {
    document.addEventListener("keydown", this.onKey);
    this.load();
  }
  componentWillUnmount() {
    this._alive = false;
    document.removeEventListener("keydown", this.onKey);
  }
  video() {
    return this.el ? this.el.querySelector("video") : null;
  }
  render() {
    const {
      asset,
      onClose
    } = this.props;
    const {
      start,
      end,
      busy,
      step,
      versions
    } = this.state;
    const dur = Number(asset.durationSeconds) || 0;
    return /*#__PURE__*/React.createElement(EditFrame, {
      inline: this.props.inline,
      busy: busy,
      onClose: onClose,
      innerRef: r => {
        this.el = r;
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-head"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
      className: "hub-h3",
      style: {
        margin: 0
      }
    }, "Trim: ", asset.title || "Video"), /*#__PURE__*/React.createElement("div", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, dur ? `${fmt(dur)} long · ` : "", "v", asset.version || 1, versions.length > 1 ? ` of ${versions.length}` : "", " \xB7 free")), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle sm",
      disabled: busy,
      onClick: onClose
    }, "Close")), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-stage"
    }, /*#__PURE__*/React.createElement(ClipPlayer, {
      src: asset.url,
      poster: asset.posterUrl,
      className: "hub-player",
      style: {
        maxHeight: "56vh"
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "territory-hint hub-edit-stagehint"
    }, "Play to the moment, then set the start or end from the playhead. ", busy && /*#__PURE__*/React.createElement("span", {
      className: "plk-chip info",
      style: {
        marginLeft: 8
      }
    }, step)), versions.length > 1 && /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-versions"
    }, versions.slice().reverse().map(v => /*#__PURE__*/React.createElement("a", {
      key: String(v.id),
      className: "hub-edit-ver" + (String(v.id) === String(asset.id) ? " on" : ""),
      href: v.url,
      target: "_blank",
      rel: "noreferrer"
    }, v.posterUrl ? /*#__PURE__*/React.createElement("img", {
      src: v.posterUrl,
      alt: ""
    }) : /*#__PURE__*/React.createElement("span", {
      style: {
        display: "block",
        height: 72,
        background: "#111",
        borderRadius: 4
      }
    }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, v.parentAssetId ? `v${v.version}` : "Original"), v.durationSeconds ? ` · ${fmt(v.durationSeconds)}` : "", /*#__PURE__*/React.createElement("i", null, (v.title || "").split(" · ").pop())))))), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-tools"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-group",
      style: {
        marginTop: 0
      }
    }, "Range"), /*#__PURE__*/React.createElement("div", {
      className: "hub-range"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-range-bar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        left: `${dur ? Math.min(100, start / dur * 100) : 0}%`,
        width: `${dur ? Math.max(0, Math.min(100, (end - start) / dur * 100)) : 100}%`
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "hub-range-fields"
    }, /*#__PURE__*/React.createElement("label", null, "Start", /*#__PURE__*/React.createElement("input", {
      type: "number",
      min: "0",
      step: "0.1",
      value: start,
      onChange: e => this.setState({
        start: num(e.target.value, 0)
      }),
      onBlur: () => this.seek(start)
    }), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle xs",
      title: "Use the playhead",
      onClick: () => this.setFromPlayer("start")
    }, "playhead")), /*#__PURE__*/React.createElement("label", null, "End", /*#__PURE__*/React.createElement("input", {
      type: "number",
      min: "0",
      step: "0.1",
      value: end,
      onChange: e => this.setState({
        end: num(e.target.value, 0)
      }),
      onBlur: () => this.seek(end)
    }), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle xs",
      title: "Use the playhead",
      onClick: () => this.setFromPlayer("end")
    }, "playhead"))), /*#__PURE__*/React.createElement("div", {
      className: "hub-range-quick"
    }, [6, 15, 30].filter(n => !dur || n < dur).map(n => /*#__PURE__*/React.createElement("button", {
      key: n,
      className: "territory-toggle xs",
      onClick: () => this.setState({
        end: Math.min(dur || start + n, Math.round((start + n) * 10) / 10)
      })
    }, n, " s from start")), dur ? /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle xs",
      onClick: () => this.setState({
        start: 0,
        end: dur
      })
    }, "Whole video") : null), /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, "Clip ", fmt(Math.max(0, end - start)), " \xB7 audio kept \xB7 the original stays untouched")), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-commit"
    }, /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, fmt(start), " to ", fmt(end), " \xB7 saved as v", versions.length + 1), /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      disabled: busy || !(end > start),
      onClick: this.apply
    }, busy && step === "Cutting…" ? "Cutting…" : "Cut")), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-group",
      style: {
        marginTop: 18
      }
    }, "Extend the clip"), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-opts",
      style: {
        marginTop: 4
      }
    }, /*#__PURE__*/React.createElement("textarea", {
      rows: 3,
      value: this.state.extendPrompt || "",
      placeholder: "What happens next, e.g. the camera pulls back to show the whole room",
      onChange: e => this.setState({
        extendPrompt: e.target.value
      })
    }), /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, "Adds 8 seconds generated from the last frame of the whole video, matched to its look. Saved as a new version.")), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-commit"
    }, /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, fmt(dur), " becomes ", fmt(dur + 8), " \xB7 saved as v", versions.length + 1), /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
      disabled: busy || !(this.state.extendPrompt || "").trim(),
      onClick: this.extend
    }, busy && step.startsWith("Extending") ? "Extending…" : "Extend 8 s")))));
  }
}

/** Clips: the clip agent proposes cuts from scene changes plus the transcript; pick and make them. */
export class ClipsModal extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      clips: undefined,
      picked: new Set(),
      busy: false,
      step: "",
      transcript: null,
      target: "social",
      made: 0
    });
    _defineProperty(this, "_alive", true);
    _defineProperty(this, "onKey", e => {
      if (e.key === "Escape" && !this.state.busy) this.props.onClose();
    });
    _defineProperty(this, "loadTranscript", async () => {
      const t = await safe(svc(`/content/assets/${String(this.props.asset.id)}/transcript`).getAsync(), null);
      if (this._alive) this.setState({
        transcript: t && (t.text || (t.segments || []).length) ? t : null
      });
    });
    _defineProperty(this, "find", async () => {
      const a = this.props.asset;
      const {
        transcript,
        target
      } = this.state;
      this.setState({
        busy: true,
        step: "Finding clips…",
        clips: undefined
      });
      try {
        const p = {
          videoUrl: a.url,
          target
        };
        if (transcript && transcript.text) p.transcript = String(transcript.text).slice(0, 6000);
        if (transcript && transcript.segments && transcript.segments.length) p.segments = JSON.stringify(transcript.segments.slice(0, 120));
        const r = await runAgent("content_clip_agent", "Propose clips", p);
        const done = await waitAgent(runIdOf(r), 4000, 60);
        let clips = done && done.res && Array.isArray(done.res.clips) ? done.res.clips : null;
        if (!clips) {
          try {
            const raw = String(done && done.run && (done.run.runResult || done.run.RunResult) || "");
            const j = JSON.parse(raw.slice(raw.indexOf("{"), raw.lastIndexOf("}") + 1));
            clips = j.clips;
          } catch (e) {
            clips = null;
          }
        }
        clips = (clips || []).filter(c => c && Number(c.end) > Number(c.start)).slice(0, 8).map(c => ({
          start: Math.round(Number(c.start) * 10) / 10,
          end: Math.round(Number(c.end) * 10) / 10,
          label: c.label || "Clip",
          why: c.why || ""
        }));
        if (this._alive) this.setState({
          clips,
          picked: new Set(clips.map((_, i) => i))
        });
        if (!clips.length) toast(done && done.timeout ? "Still looking: try again in a minute." : "No clips were proposed for this video.");
      } catch (e) {
        toast(e && e.message || "Could not run the clip agent.");
      } finally {
        if (this._alive) this.setState({
          busy: false,
          step: ""
        });
      }
    });
    _defineProperty(this, "make", async () => {
      const {
        clips,
        picked
      } = this.state;
      const a = this.props.asset;
      const chosen = (clips || []).filter((_, i) => picked.has(i));
      if (!chosen.length) return;
      const batchId = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : String(Date.now());
      this.setState({
        busy: true,
        made: 0
      });
      let made = 0;
      let last = null;
      try {
        for (let i = 0; i < chosen.length; i++) {
          const c = chosen[i];
          if (this._alive) this.setState({
            step: `Cutting ${i + 1} of ${chosen.length}…`
          });
          const v = await trimToVersion(a, c.start, c.end, c.label, batchId);
          if (v) {
            made++;
            last = v;
            if (this._alive) this.setState({
              made
            });
          }
        }
        toast(`${made} of ${chosen.length} clip${chosen.length === 1 ? "" : "s"} saved as versions.`);
        if (this.props.onSaved && last) this.props.onSaved(last);
      } catch (e) {
        toast(e && e.message || "Could not make the clips.");
      } finally {
        if (this._alive) this.setState({
          busy: false,
          step: ""
        });
      }
    });
    _defineProperty(this, "seek", t => {
      const v = this.el ? this.el.querySelector("video") : null;
      if (v) {
        v.currentTime = Number(t) || 0;
        v.play && v.play().catch(() => {});
      }
    });
  }
  componentDidMount() {
    document.addEventListener("keydown", this.onKey);
    this.loadTranscript();
  }
  componentWillUnmount() {
    this._alive = false;
    document.removeEventListener("keydown", this.onKey);
  }
  render() {
    const {
      asset,
      onClose
    } = this.props;
    const {
      clips,
      picked,
      busy,
      step,
      transcript,
      target
    } = this.state;
    return /*#__PURE__*/React.createElement(EditFrame, {
      inline: this.props.inline,
      busy: busy,
      onClose: onClose,
      innerRef: r => {
        this.el = r;
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-head"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
      className: "hub-h3",
      style: {
        margin: 0
      }
    }, "Clips: ", asset.title || "Video"), /*#__PURE__*/React.createElement("div", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, asset.durationSeconds ? `${fmt(asset.durationSeconds)} long · ` : "", transcript ? "transcript found · " : "no transcript yet · scene changes only · ", "free")), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle sm",
      disabled: busy,
      onClick: onClose
    }, "Close")), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-stage"
    }, /*#__PURE__*/React.createElement(ClipPlayer, {
      src: asset.url,
      poster: asset.posterUrl,
      className: "hub-player",
      style: {
        maxHeight: "44vh"
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "territory-hint hub-edit-stagehint"
    }, clips === undefined ? `The agent reads the scene changes${transcript ? " and the transcript" : ""} and proposes 3 to 6 short clips.` : clips.length ? "Pick the clips to make. Preview plays from the clip start." : "No clips were proposed.", " ", busy && /*#__PURE__*/React.createElement("span", {
      className: "plk-chip info",
      style: {
        marginLeft: 8
      }
    }, step)), clips && clips.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "hub-clips"
    }, clips.map((c, i) => /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "hub-clip-row" + (picked.has(i) ? " on" : "")
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: picked.has(i),
      disabled: busy,
      onChange: () => {
        const n = new Set(picked);
        if (n.has(i)) n.delete(i);else n.add(i);
        this.setState({
          picked: n
        });
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "hub-clip-main"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-clip-title"
    }, /*#__PURE__*/React.createElement("b", null, c.label), /*#__PURE__*/React.createElement("span", {
      className: "plk-chip"
    }, fmt(c.start), " to ", fmt(c.end), " \xB7 ", Math.round(c.end - c.start), " s")), c.why ? /*#__PURE__*/React.createElement("div", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, c.why) : null), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle sm",
      disabled: busy,
      onClick: () => this.seek(c.start)
    }, "Preview"))), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-commit"
    }, /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, picked.size, " of ", clips.length, " picked \xB7 each saved as a version"), /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      disabled: busy || !picked.size,
      onClick: this.make
    }, busy && step.startsWith("Cutting") ? step : "Make clips")))), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-tools"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-opts",
      style: {
        marginTop: 0
      }
    }, /*#__PURE__*/React.createElement("label", null, "For", /*#__PURE__*/React.createElement("select", {
      value: target,
      onChange: e => this.setState({
        target: e.target.value
      })
    }, [["social", "Social (Reels, Stories)"], ["ads", "Ads"], ["product page", "Product page"], ["email", "Email"]].map(([k, l]) => /*#__PURE__*/React.createElement("option", {
      key: k,
      value: k
    }, l)))), /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, "Shapes the length and the moments the agent picks."), /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid " + (clips === undefined ? "k-button-solid-primary" : "k-button-solid-base"),
      disabled: busy,
      onClick: this.find
    }, busy && step.startsWith("Finding") ? "Finding…" : clips === undefined ? "Find clips" : "Find again")))));
  }
}

/** Video Edit Mode: segments on a timeline, captions from the transcript in the brand preset, overlays, music, end card. */
export class VideoEditModal extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      segments: [{
        start: 0,
        end: 0,
        caption: "",
        overlay: "",
        label: "Clip 1"
      }],
      captions: true,
      aspect: "",
      music: "",
      endCard: false,
      endTitle: "",
      endSub: "",
      separate: false,
      busy: false,
      step: "",
      transcript: null,
      brand: {}
    });
    _defineProperty(this, "_alive", true);
    _defineProperty(this, "onKey", e => {
      if (e.key === "Escape" && !this.state.busy) this.props.onClose();
    });
    _defineProperty(this, "load", async () => {
      const a = this.props.asset;
      const dur = Number(a.durationSeconds) || 0;
      const [t, brand] = await Promise.all([safe(svc(`/content/assets/${String(a.id)}/transcript`).getAsync(), null), loadBrandKit()]);
      const segs = [{
        start: 0,
        end: dur,
        caption: "",
        overlay: "",
        label: "Clip 1"
      }];
      if (t && t.segments && t.segments.length) segs[0].caption = t.segments.map(x => x.text).join(" ").slice(0, 600);else if (t && t.text) segs[0].caption = String(t.text).slice(0, 600);
      if (this._alive) this.setState({
        segments: segs,
        transcript: t && (t.text || (t.segments || []).length) ? t : null,
        brand: brand || {},
        endTitle: brand && brand.company || ""
      });
    });
    _defineProperty(this, "set", (i, patch) => {
      const segments = this.state.segments.map((sg, k) => k === i ? {
        ...sg,
        ...patch
      } : sg);
      this.setState({
        segments
      });
    });
    _defineProperty(this, "splitAt", () => {
      const t = this.playhead();
      const segs = this.state.segments;
      const i = segs.findIndex(sg => t > sg.start + 0.3 && t < sg.end - 0.3);
      if (i < 0) {
        toast("Move the playhead inside a clip to split it.");
        return;
      }
      const a = {
        ...segs[i],
        end: t,
        caption: this.captionFor(segs[i].start, t) || segs[i].caption,
        label: segs[i].label
      };
      const b = {
        ...segs[i],
        start: t,
        caption: this.captionFor(t, segs[i].end),
        overlay: "",
        label: `Clip ${segs.length + 1}`
      };
      const segments = [...segs.slice(0, i), a, b, ...segs.slice(i + 1)];
      this.setState({
        segments
      });
    });
    _defineProperty(this, "move", (i, d) => {
      const segs = this.state.segments.slice();
      const j = i + d;
      if (j < 0 || j >= segs.length) return;
      [segs[i], segs[j]] = [segs[j], segs[i]];
      this.setState({
        segments: segs
      });
    });
    _defineProperty(this, "remove", i => {
      if (this.state.segments.length <= 1) return;
      this.setState({
        segments: this.state.segments.filter((_, k) => k !== i)
      });
    });
    _defineProperty(this, "render_", async () => {
      const a = this.props.asset;
      const {
        segments,
        captions,
        aspect,
        music,
        endCard,
        endTitle,
        endSub,
        separate,
        brand
      } = this.state;
      const segs = segments.filter(sg => Number(sg.end) > Number(sg.start) + 0.2);
      if (!segs.length) {
        toast("Add at least one clip.");
        return;
      }
      const spec = {
        sourceUrl: a.url,
        segments: segs.map(sg => ({
          start: Number(sg.start),
          end: Number(sg.end),
          caption: captions ? sg.caption : "",
          overlay: sg.overlay || "",
          label: sg.label || ""
        })),
        aspectRatio: aspect || null,
        captions,
        preset: {
          font: brand.captionFont || "DejaVu Sans",
          textColor: brand.captionTextColor || "#ffffff",
          backColor: brand.captionBackColor || "#000000",
          backOpacity: brand.captionBackOpacity != null ? Number(brand.captionBackOpacity) : 0.6,
          position: brand.captionPosition || "bottom",
          size: brand.captionSize != null ? Number(brand.captionSize) : 0.044,
          bold: true
        },
        musicUrl: music.trim() || null,
        musicVolume: 0.3,
        crossfade: true,
        endCard: endCard && endTitle.trim() ? {
          title: endTitle.trim(),
          subtitle: endSub.trim() || null,
          brandColor: brand.accent || "#1a1a1a",
          textColor: "#ffffff",
          logoUrl: brand.logoUrl && !/\.svg(\?|$)/i.test(brand.logoUrl) ? brand.logoUrl : null,
          seconds: 2.5
        } : null,
        saveSegmentsSeparately: separate
      };
      this.setState({
        busy: true,
        step: "Rendering…"
      });
      try {
        const r = await runAgent("content_video_edit_agent", "Render the edit", {
          spec: JSON.stringify(spec)
        });
        const done = await waitAgent(runIdOf(r), 5000, 120);
        const ctx = done && done.ctx || {};
        const res = done && done.res || {};
        const results = ctx.results || res.results || [];
        if (!done.ok || !results.length) {
          toast(done && done.timeout ? "Still rendering: the version will appear in Assets." : "The render did not finish.");
          return;
        }
        const batchId = uuid();
        let last = null;
        for (let i = 0; i < results.length; i++) {
          const x = results[i];
          const saved = await safe(svc(`/content/assets/${String(a.id)}/edits`).postAsync({
            action: "video_edit",
            params: JSON.stringify({
              segments: spec.segments.length,
              captions,
              aspect: aspect || null,
              endCard: !!spec.endCard
            }),
            status: "done",
            url: x.url,
            width: x.width || null,
            height: x.height || null,
            durationSeconds: Math.round(Number(x.seconds || 0)) || null,
            posterUrl: x.posterUrl || null,
            label: results.length > 1 ? x.label || `Clip ${i + 1}` : "Edit",
            credits: 0,
            batchId
          }), null);
          if (saved && saved.version) last = saved.version;
        }
        toast(results.length > 1 ? `${results.length} clips saved as versions.` : `Saved as v${last ? last.version : "?"}.`);
        if (this.props.onSaved) this.props.onSaved(last);
        this.props.onClose();
      } catch (e) {
        toast(e && e.message || "Could not start the render.");
      } finally {
        if (this._alive) this.setState({
          busy: false,
          step: ""
        });
      }
    });
  }
  componentDidMount() {
    document.addEventListener("keydown", this.onKey);
    this.load();
  }
  componentWillUnmount() {
    this._alive = false;
    document.removeEventListener("keydown", this.onKey);
  }
  video() {
    return this.el ? this.el.querySelector("video") : null;
  }
  playhead() {
    const v = this.video();
    return v ? Math.round(v.currentTime * 10) / 10 : 0;
  }
  captionFor(start, end) {
    const t = this.state.transcript;
    if (t && t.segments && t.segments.length) return t.segments.filter(x => Number(x.end) > start && Number(x.start) < end).map(x => x.text).join(" ").slice(0, 600);
    return "";
  }
  render() {
    const {
      asset,
      onClose
    } = this.props;
    const {
      segments,
      captions,
      aspect,
      music,
      endCard,
      endTitle,
      endSub,
      separate,
      busy,
      step,
      transcript,
      brand
    } = this.state;
    const dur = Number(asset.durationSeconds) || Math.max(...segments.map(sg => Number(sg.end) || 0), 1);
    const total = segments.reduce((n, sg) => n + Math.max(0, Number(sg.end) - Number(sg.start)), 0);
    const palette = ["var(--plk-accent)", "var(--plk-info-text)", "var(--plk-success-text)", "var(--plk-warning-text)", "var(--plk-text-muted)"];
    return /*#__PURE__*/React.createElement(EditFrame, {
      inline: this.props.inline,
      busy: busy,
      onClose: onClose,
      style: {
        width: 1180
      },
      innerRef: r => {
        this.el = r;
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-head"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
      className: "hub-h3",
      style: {
        margin: 0
      }
    }, "Edit: ", asset.title || "Video"), /*#__PURE__*/React.createElement("div", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, dur ? `${fmt(dur)} long · ` : "", transcript ? "captions from the transcript · " : "no transcript: type captions per clip · ", "free")), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle sm",
      disabled: busy,
      onClick: onClose
    }, "Close")), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-body",
      style: {
        gridTemplateColumns: "minmax(0, 1fr) 320px"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-stage"
    }, /*#__PURE__*/React.createElement(ClipPlayer, {
      src: asset.url,
      poster: asset.posterUrl,
      className: "hub-player",
      style: {
        maxHeight: "34vh"
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "hub-vtl"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-vtl-strip",
      title: "The clips in order, to scale"
    }, segments.map((sg, i) => {
      const w = dur ? Math.max(2, (Number(sg.end) - Number(sg.start)) / dur * 100) : 100 / segments.length;
      return /*#__PURE__*/React.createElement("span", {
        key: i,
        style: {
          width: `${w}%`,
          background: palette[i % palette.length]
        }
      }, /*#__PURE__*/React.createElement("b", null, sg.label || `Clip ${i + 1}`), /*#__PURE__*/React.createElement("i", null, fmt(Math.max(0, Number(sg.end) - Number(sg.start)))));
    })), /*#__PURE__*/React.createElement("div", {
      className: "hub-vtl-bar"
    }, /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle sm",
      disabled: busy,
      onClick: this.splitAt
    }, "Split at playhead"), /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, segments.length, " clip", segments.length === 1 ? "" : "s", " \xB7 ", fmt(total), " total \xB7 play to a moment and split there"), busy && /*#__PURE__*/React.createElement("span", {
      className: "plk-chip info"
    }, step)), /*#__PURE__*/React.createElement("div", {
      className: "hub-vtl-grid"
    }, segments.map((sg, i) => /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "hub-vtl-seg"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-vtl-seghead"
    }, /*#__PURE__*/React.createElement("span", {
      className: "hub-vtl-dot",
      style: {
        background: palette[i % palette.length]
      }
    }), /*#__PURE__*/React.createElement("input", {
      className: "hub-vtl-label",
      value: sg.label || "",
      placeholder: `Clip ${i + 1}`,
      onChange: e => this.set(i, {
        label: e.target.value
      })
    }), /*#__PURE__*/React.createElement("span", {
      className: "hub-vtl-tools"
    }, /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle xs",
      title: "Move up",
      disabled: i === 0,
      onClick: () => this.move(i, -1)
    }, "\u2191"), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle xs",
      title: "Move down",
      disabled: i === segments.length - 1,
      onClick: () => this.move(i, 1)
    }, "\u2193"), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle xs",
      title: "Remove this clip",
      disabled: segments.length <= 1,
      onClick: () => this.remove(i)
    }, "\u2715"))), /*#__PURE__*/React.createElement("div", {
      className: "hub-range-fields"
    }, /*#__PURE__*/React.createElement("label", null, "Start", /*#__PURE__*/React.createElement("input", {
      type: "number",
      step: "0.1",
      min: "0",
      value: sg.start,
      onChange: e => this.set(i, {
        start: num(e.target.value, 0)
      })
    }), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle xs",
      title: "Use the playhead",
      onClick: () => this.set(i, {
        start: this.playhead()
      })
    }, "playhead")), /*#__PURE__*/React.createElement("label", null, "End", /*#__PURE__*/React.createElement("input", {
      type: "number",
      step: "0.1",
      min: "0",
      value: sg.end,
      onChange: e => this.set(i, {
        end: num(e.target.value, 0)
      })
    }), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle xs",
      title: "Use the playhead",
      onClick: () => this.set(i, {
        end: this.playhead()
      })
    }, "playhead"))), /*#__PURE__*/React.createElement("label", {
      className: "hub-vtl-field"
    }, "On-screen text", /*#__PURE__*/React.createElement("input", {
      value: sg.overlay || "",
      placeholder: "A few words shown over this clip (optional)",
      onChange: e => this.set(i, {
        overlay: e.target.value
      })
    })), captions && /*#__PURE__*/React.createElement("label", {
      className: "hub-vtl-field"
    }, "Caption", /*#__PURE__*/React.createElement("textarea", {
      rows: 2,
      value: sg.caption || "",
      placeholder: transcript ? "Words from the transcript for this clip" : "Words spoken in this clip",
      onChange: e => this.set(i, {
        caption: e.target.value
      })
    }))))))), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-tools"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-group",
      style: {
        marginTop: 0
      }
    }, "Output"), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-opts",
      style: {
        marginTop: 4
      }
    }, /*#__PURE__*/React.createElement("label", null, "Aspect", /*#__PURE__*/React.createElement("select", {
      value: aspect,
      onChange: e => this.setState({
        aspect: e.target.value
      })
    }, [["", "Keep source"], ["16:9", "Wide 16:9"], ["9:16", "Tall 9:16"], ["1:1", "Square 1:1"], ["4:5", "Portrait 4:5"]].map(([k, l]) => /*#__PURE__*/React.createElement("option", {
      key: k,
      value: k
    }, l)))), /*#__PURE__*/React.createElement("span", {
      className: "seg"
    }, [[false, "One cut"], [true, "One per clip"]].map(([v, l]) => /*#__PURE__*/React.createElement("button", {
      key: String(v),
      className: separate === v ? "on" : "",
      onClick: () => this.setState({
        separate: v
      })
    }, l))), /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, separate ? "Each clip becomes its own version." : "Clips join with crossfades into one version.")), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-group"
    }, "Captions"), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-opts",
      style: {
        marginTop: 4
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "seg"
    }, [[true, "Burn in"], [false, "None"]].map(([v, l]) => /*#__PURE__*/React.createElement("button", {
      key: String(v),
      className: captions === v ? "on" : "",
      onClick: () => this.setState({
        captions: v
      })
    }, l))), captions && /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, "Brand style: ", (brand.captionFont || "DejaVu Sans").replace("DejaVu ", ""), ", ", brand.captionPosition || "bottom", ". Change it under Settings \u2192 Brand kit \u2192 Captions.")), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-group"
    }, "Audio"), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-opts",
      style: {
        marginTop: 4
      }
    }, /*#__PURE__*/React.createElement("input", {
      value: music,
      placeholder: "Music bed URL (optional, mp3)",
      onChange: e => this.setState({
        music: e.target.value
      })
    }), /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, "Loops quietly under the clip audio.")), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-group"
    }, "End card"), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-opts",
      style: {
        marginTop: 4
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "seg"
    }, [[false, "Off"], [true, "Brand color"]].map(([v, l]) => /*#__PURE__*/React.createElement("button", {
      key: String(v),
      className: endCard === v ? "on" : "",
      onClick: () => this.setState({
        endCard: v
      })
    }, l))), endCard && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      value: endTitle,
      placeholder: "Title",
      onChange: e => this.setState({
        endTitle: e.target.value
      })
    }), /*#__PURE__*/React.createElement("input", {
      value: endSub,
      placeholder: "Subtitle (optional)",
      onChange: e => this.setState({
        endSub: e.target.value
      })
    }))), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-commit"
    }, /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, separate ? `${segments.length} version${segments.length === 1 ? "" : "s"}` : `${fmt(total + (endCard ? 2.5 : 0))} · one version`), /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      disabled: busy || !segments.length,
      onClick: this.render_
    }, busy ? "Working…" : "Render")))));
  }
}

/** Video Smart Resize: a safe zone drawn on the frame, channel sizes, blur or color fill. Free. */
export class VideoResizeModal extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      safe: null,
      fill: "blur",
      fillColor: "#000000",
      picked: new Set(["story", "square"]),
      busy: false,
      step: "",
      results: null
    });
    _defineProperty(this, "_alive", true);
    _defineProperty(this, "onKey", e => {
      if (e.key === "Escape" && !this.state.busy) this.props.onClose();
    });
    _defineProperty(this, "toggle", k => {
      const picked = new Set(this.state.picked);
      if (picked.has(k)) picked.delete(k);else picked.add(k);
      this.setState({
        picked
      });
    });
    _defineProperty(this, "run", async () => {
      const a = this.props.asset;
      const {
        safe: safeRect,
        fill,
        fillColor,
        picked
      } = this.state;
      const targets = VIDEO_TARGETS.filter(([k]) => picked.has(k)).map(([, label, width, height]) => ({
        label,
        width,
        height
      }));
      if (!targets.length) return;
      this.setState({
        busy: true,
        step: `Resizing to ${targets.length} size${targets.length === 1 ? "" : "s"}…`,
        results: null
      });
      const batchId = uuid();
      try {
        const p = {
          videoUrl: a.url,
          targets: JSON.stringify(targets),
          fill,
          fillColor
        };
        if (safeRect) p.safe = JSON.stringify(safeRect);
        const r = await runAgent("content_video_resize_agent", `Resize to ${targets.length} sizes`, p);
        const done = await waitAgent(runIdOf(r), 5000, 120);
        const ctx = done && done.ctx || {};
        const res = done && done.res || {};
        const results = ctx.results || res.results || [];
        if (!done.ok || !results.length) {
          toast(done && done.timeout ? "Still working: the sizes will appear in Assets." : "The resize did not finish.");
          return;
        }
        const saved = [];
        for (const x of results) {
          const s = await safe(svc(`/content/assets/${String(a.id)}/edits`).postAsync({
            action: "video_resize",
            params: JSON.stringify({
              ...p,
              target: x.label
            }),
            status: "done",
            url: x.url,
            width: x.width,
            height: x.height,
            durationSeconds: Math.round(Number(x.seconds || 0)) || null,
            posterUrl: x.posterUrl || null,
            label: `${x.label} ${x.width}x${x.height}`,
            credits: 0,
            batchId
          }), null);
          saved.push({
            ...x,
            version: s && s.version
          });
        }
        if (this._alive) this.setState({
          results: saved
        });
        toast(`${saved.length} size${saved.length === 1 ? "" : "s"} saved as versions.`);
        if (this.props.onSaved) this.props.onSaved(saved.map(x => x.version).filter(Boolean));
      } catch (e) {
        toast(e && e.message || "Could not start the resize.");
      } finally {
        if (this._alive) this.setState({
          busy: false,
          step: ""
        });
      }
    });
  }
  componentDidMount() {
    document.addEventListener("keydown", this.onKey);
  }
  componentWillUnmount() {
    this._alive = false;
    document.removeEventListener("keydown", this.onKey);
  }
  render() {
    const {
      asset,
      onClose
    } = this.props;
    const {
      safe: safeRect,
      fill,
      fillColor,
      picked,
      busy,
      step,
      results
    } = this.state;
    const n = picked.size;
    return /*#__PURE__*/React.createElement(EditFrame, {
      inline: this.props.inline,
      busy: busy,
      onClose: onClose
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-head"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
      className: "hub-h3",
      style: {
        margin: 0
      }
    }, "Resize: ", asset.title || "Video"), /*#__PURE__*/React.createElement("div", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, asset.width && asset.height ? `${asset.width}×${asset.height} · ` : "", asset.durationSeconds ? `${fmt(asset.durationSeconds)} · ` : "", "free")), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle sm",
      disabled: busy,
      onClick: onClose
    }, "Close")), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-stage"
    }, /*#__PURE__*/React.createElement(FrameRect, {
      src: asset.url,
      rect: safeRect,
      onRect: r => this.setState({
        safe: r
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: "territory-hint hub-edit-stagehint"
    }, safeRect ? "Safe zone set: it stays in frame in every size. Drag again to change it." : "Drag a safe zone over the product or text. Sizes that cannot fit it are padded instead of cropped.", " ", busy && /*#__PURE__*/React.createElement("span", {
      className: "plk-chip info",
      style: {
        marginLeft: 8
      }
    }, step)), results && /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-versions"
    }, results.map((x, i) => /*#__PURE__*/React.createElement("a", {
      key: i,
      className: "hub-edit-ver on",
      href: x.url,
      target: "_blank",
      rel: "noreferrer"
    }, x.posterUrl ? /*#__PURE__*/React.createElement("img", {
      src: x.posterUrl,
      alt: ""
    }) : /*#__PURE__*/React.createElement("span", {
      style: {
        display: "block",
        height: 72,
        background: "#111",
        borderRadius: 4
      }
    }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, x.label), " \xB7 ", x.width, "\xD7", x.height))))), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-tools"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-opts",
      style: {
        marginTop: 0
      }
    }, /*#__PURE__*/React.createElement("b", {
      style: {
        fontSize: 12
      }
    }, "Fill when it cannot crop"), /*#__PURE__*/React.createElement("span", {
      className: "seg"
    }, [["blur", "Blurred video"], ["color", "Color"]].map(([k, l]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      className: fill === k ? "on" : "",
      disabled: busy,
      onClick: () => this.setState({
        fill: k
      })
    }, l))), fill === "color" && /*#__PURE__*/React.createElement("label", null, "Color", /*#__PURE__*/React.createElement("input", {
      type: "color",
      value: fillColor,
      onChange: e => this.setState({
        fillColor: e.target.value
      })
    }))), /*#__PURE__*/React.createElement("b", {
      style: {
        fontSize: 12,
        display: "block",
        marginTop: 12,
        marginBottom: 6
      }
    }, "Channels"), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-channels"
    }, VIDEO_TARGETS.map(([k, label, w, h]) => /*#__PURE__*/React.createElement("label", {
      key: k,
      className: picked.has(k) ? "on" : ""
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: picked.has(k),
      disabled: busy,
      onChange: () => this.toggle(k)
    }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, label), /*#__PURE__*/React.createElement("i", null, w, "\xD7", h))))), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-commit"
    }, /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, n, " size", n === 1 ? "" : "s", " \xB7 each saved as a version"), /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      disabled: busy || !n,
      onClick: this.run
    }, busy ? "Working…" : "Create set")))));
  }
}